import type { DomainLoanApplicationDetails } from "@porchpass/api-client";
import { DomainHomeSectionType } from "@porchpass/api-client";

export const API_PREFIX_PATH = "/dealer-portal/v1";
export const zeroDate = "0001-01-01T00:00:00Z";
export const currentYear = new Date().getFullYear();
export const HEADER_HEIGHT = 67;

export const defaultApplication: DomainLoanApplicationDetails = {
  application_id: "",
  borrower: {
    id: "",
    first_name: "",
    last_name: "",
    email: "",
    phone_number: "",
  },
  co_borrowers: [],
  los_id: "",
  application_status: undefined,
  loan_amount: 0,
  total_amount: 0,
  down_payment_amount: 0,
  estimated_monthly_payment: 0,
  interest_rate: 0,
  loan_officer: { name: "", phone_number: "" },
  application_date: "",
  last_updated_at: "",
  target_delivery_date: "",
  target_funding_date: "",
  section_type: DomainHomeSectionType.HomeSectionSingleWide,
  sales_rep: { name: "", email: "" },
  team_members: [],
  lenders: [],
  primary_lender: undefined,
};
export const APPLICATION_STATUSES = {
  DRAFT: "Draft",
  AWAITING_SIGNATURE: "Awaiting Signature",
  INVITED: "Invited",
  REOPENED_FOR_EDIT: "Re-opened for edit",
  READY_TO_SUBMIT: "Ready to submit",
  SUBMITTED: "Submitted",
  SUBMISSION_FAILED: "Submission failed",
  PRE_APPROVED: "Pre-approved",
  CLEAR_TO_CLOSE: "Clear to close",
  CLOSED: "Closed",
  FUNDED: "Funded",
  DECLINED: "Declined",
  UNKNOWN: "Unknown",
} as const;
export const APPLICATION_STATUS_KEYS = {
  Draft: "DRAFT",
  "Awaiting Signature": "AWAITING_SIGNATURE",
  Invited: "INVITED",
  "Re-opened for edit": "REOPENED_FOR_EDIT",
  "Ready to submit": "READY_TO_SUBMIT",
  Submitted: "SUBMITTED",
  "Submission failed": "SUBMISSION_FAILED",
  "Pre-approved": "PRE_APPROVED",
  "Clear to close": "CLEAR_TO_CLOSE",
  Closed: "CLOSED",
  Funded: "FUNDED",
  Declined: "DECLINED",
  Unknown: "UNKNOWN",
} as const;
export const ApplicationStatusList = [
  "Draft",
  "Awaiting Signature",
  "Invited",
  "Re-opened for edit",
  "Ready to submit",
  "Submitted",
  "Pre-approved",
  "Clear to close",
  "Closed",
  "Funded",
  "Declined",
];
